/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import i18n from '@/i18n'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { safeGet } from '@src/util/common.js'
import { SaasAxios } from '@quick/saas-axios'
import { registerTitle } from '@constants/register'
const UnifiedRegisterMobile = () =>
  import('@views/UnifiedRegisterMobile/index.vue')
const UnifiedRegisterMobile2 = () =>
  import('@views/UnifiedRegisterMobile2/index.vue')
const CreateDone = () => import('@views/CreateDone/index.vue')
const CreateGuide = () => import('@views/CreateGuide/index.vue')
const findCompanyName = () => import('@views/findCompanyName/index.vue')
const DomainVerify = () => import('@views/DomainVerify/index.vue')
const SignUp = () => import('@views/SignUp/index.vue')
const CorpGuide = () => import('@views/CorpGuide/index.vue')
const InviteMembers = () => import('@views/InviteMembers/index.vue')
const TouristGuide = () => import('@views/TouristGuide/index.vue')
const CreateGuideMobile = () => import('@views/CreateGuideMobile/index.vue')
const AtomicGuide = () => import('@views/AtomicGuide/index.vue')
import { isMobile } from '@util'
Vue.use(VueRouter)
const dosOSIcon = 'https://js2.epy.wpscdn.cn/security/docswebbuy_register.png'
const SEM_ROUTE_NAME = 'SemRegister'
const UNIFIED_REGISTER_NAME = 'UnifiedRegister'
const UNIFIED_REGISTER_MOBILE_NAME = 'UnifiedRegisterMobile'
const DOMAIN_VERIFY_NAME = 'DomainVerify'
const SIGN_UP_NAME = 'SignUp'
const CROP_GUIDE_NAME = 'CorpGuide'
const INVITE_MEMBERS_NAME = 'InvteMembers'
const TOURIST_GUIDE_NAME = 'TouristGuide'
const ATOMIC_GUIDE_NAME = 'AtomicGuide'
export const routes = [
  {
    path: '/sign-up',
    name: SIGN_UP_NAME,
    component: SignUp,
    meta: {
      title: registerTitle,
      checkWhitePageEl: ['#sign_up'],
    },
  },
  {
    path: '/domain-verify',
    name: DOMAIN_VERIFY_NAME,
    component: DomainVerify,
    meta: {
      title: registerTitle,
      checkWhitePageEl: ['#domain_verify'],
    },
  },
  // 钩子已做重定向处理
  {
    path: '/unifiedRegister',
    name: UNIFIED_REGISTER_NAME,
  },
  {
    path: '/unified-register-mobile',
    name: UNIFIED_REGISTER_MOBILE_NAME,
    component: UnifiedRegisterMobile,
    meta: {
      title: i18n.t('c6225c5b2b'),
      checkWhitePageEl: ['#unified_register_mobile'],
    },
  },
  {
    path: '/unified-register-mobile2',
    name: UNIFIED_REGISTER_MOBILE_NAME,
    component: UnifiedRegisterMobile2,
    meta: {
      title: i18n.t('c6225c5b2b'),
      checkWhitePageEl: ['#unified_register_mobile'],
    },
  },
  {
    // 钩子已做重定向处理
    path: '/semregister',
    name: SEM_ROUTE_NAME,
  },
  {
    // 保留register创建企业路由，未来兼容旧的访问路由重定向到统一注册页
    path: '/register',
    name: 'Register',
  },
  {
    path: '/createDone',
    name: 'CreateDone',
    component: CreateDone,
    meta: {
      title: i18n.t('e33423fb1e'),
      utmSourceConf: {
        docsOS: {
          title: i18n.t('7b0c035999'),
          favicon: dosOSIcon,
          headIcon: dosOSIcon,
        },
      },
      checkWhitePageEl: ['#createDone_container'],
    },
  },
  {
    path: '/createGuide',
    name: 'CreateGuide',
    component: CreateGuide,
    meta: {
      title: i18n.t('fd157e8ea8'),
    },
  },
  {
    path: '/createGuideMobile',
    name: 'CreateGuideMobile',
    component: CreateGuideMobile,
    meta: {
      title: i18n.t('fd157e8ea8'),
    },
  },
  {
    path: '/findCompanyName',
    name: 'findCompanyName',
    component: findCompanyName,
    meta: {
      title: i18n.t('20591b9b44'),
      checkWhitePageEl: [],
    },
  },
  {
    path: '/corp-guide',
    name: CROP_GUIDE_NAME,
    component: CorpGuide,
    meta: {
      title: i18n.t('fd157e8ea8'),
      checkWhitePageEl: ['#crop_guide'],
    },
  },
  {
    path: '/invite-members',
    name: INVITE_MEMBERS_NAME,
    component: InviteMembers,
    meta: {
      title: i18n.t('614d9c91eb'),
      checkWhitePageEl: ['#invite_member'],
    },
  },
  {
    path: '/tourist-guide',
    name: TOURIST_GUIDE_NAME,
    component: TouristGuide,
    meta: {
      // title: '创建引导',
      checkWhitePageEl: ['#tourist-guide'],
    },
  },
  {
    path: '/atomic-guide',
    name: ATOMIC_GUIDE_NAME,
    component: AtomicGuide,
    meta: {
      title: i18n.t('713ac624b4'),
    },
  },
]
const routes3rd = routes.map(item => {
  return {
    ...item,
    path: `/3rd/plus${item.path}`,
    name: `3rd_${item.name}`,
  }
})
const routesProd = [...routes, ...routes3rd]
const router = new VueRouter({
  mode: 'history',
  base: ['Prod', 'Beta'].includes(import.meta.env.VITE_APP_KAE_ENVIRONMENT)
    ? ''
    : '/webbuy',
  routes: routesProd,
})
const changeFavicon = url => {
  var link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = url
  document.getElementsByTagName('head')[0].appendChild(link)
}

// 获取query hideComponents信息
const getHideComponents = to => {
  const nameList = [
    UNIFIED_REGISTER_NAME,
    SEM_ROUTE_NAME,
    UNIFIED_REGISTER_MOBILE_NAME,
    DOMAIN_VERIFY_NAME,
    SIGN_UP_NAME,
    CROP_GUIDE_NAME,
    INVITE_MEMBERS_NAME,
    TOURIST_GUIDE_NAME,
    ATOMIC_GUIDE_NAME,
  ]
  const nameList3rd = nameList.map(item => `3rd_${item}`)
  const isStatus = [...nameList, ...nameList3rd].includes(to.name)
  const hide_components = to.query.hide_components
  return isStatus ? 'title' : hide_components
}
router.beforeEach((to, from, next) => {
  const utm_source = to.query.utm_source
  const hideComponents = getHideComponents(to)
  //兼容自定义域名路由的跳转，防止3rd路由走到非3rd路由
  if (from.name && from.name.includes('3rd') && !to.name.includes('3rd')) {
    router.replace({
      name: '3rd_' + to.name,
      query: to.query,
    })
  }
  if (['Register', '3rd_Register'].includes(to.name)) {
    let routeName = isMobile() ? 'UnifiedRegisterMobile' : SIGN_UP_NAME
    routeName = to.name.includes('3rd') ? '3rd_' + routeName : routeName
    router.replace({
      name: routeName,
      query: to.query,
    })
  }
  if (
    [
      'SemRegister',
      'UnifiedRegister',
      '3rd_SemRegister',
      '3rd_UnifiedRegister',
    ].includes(to.name)
  ) {
    const routeName = to.name.includes('3rd')
      ? '3rd_' + SIGN_UP_NAME
      : SIGN_UP_NAME
    router.replace({
      name: routeName,
      query: to.query,
    })
  }
  // 记录需要隐藏的组件
  hideComponents &&
    router.app.$options.store.dispatch(
      'HideComponents',
      hideComponents.split(',')
    )
  const utmSourceConf = safeGet(to.meta, `utmSourceConf.${utm_source}`) || {}
  if (to.meta.title || utmSourceConf.title) {
    const title =
      utmSourceConf.title || to.meta.title || SaasAxios.getHost('PLUS')
    document.title = to.meta._title = title
  }
  if (to.meta.favicon || utmSourceConf.favicon) {
    changeFavicon(utmSourceConf.favicon || to.meta.favicon)
  }
  if (to.meta.headIcon || utmSourceConf.headIcon) {
    router.app.$options.store.dispatch(
      'HeadIcon',
      utmSourceConf.headIcon || to.meta.headIcon || ''
    )
  }
  next()
})
export default router
